// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"242":"6ed5c355","797":"159f0fc2","818":"7cf0bba1"}[chunkId] + ".chunk.js";
};